// Module
var code = `<div class="access-call-type">type</div>
<div class="access-call-access">
    <a href class="access-call-link">link</a>
</div>
<div class="access-call-syscalls">
    (<span class="access-call-syscalls-num"> </span> syscalls)
</div>`;
// Exports
export default code;